import { render } from "./FormRadioSwitchFieldComponent.vue?vue&type=template&id=267edbac&scoped=true"
import script from "./FormRadioSwitchFieldComponent.vue?vue&type=script&lang=js"
export * from "./FormRadioSwitchFieldComponent.vue?vue&type=script&lang=js"

import "./FormRadioSwitchFieldComponent.vue?vue&type=style&index=0&id=267edbac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267edbac"]])

export default __exports__